export class Inseminador {
    public cdinseminador: number;
    public nome: string;
    public cdfazenda: number;
    public removido: number;
  }
